import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import axios from 'axios';
import clsx from 'clsx';
import cfg from '../../../config.json';
import Comm from '../../../models/comm';

import { showLoading, showInfo, showErrorResponse, clearMsg } from '../../../redux/msgReducer';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';

import { CalMonthSelection } from "../../Selections";
import MyDateField from "../../MyDateField";

const useStyles = makeStyles({
    frmFilter: {
        backgroundColor: "white",
        borderCollapse: "collapse",
        //width: "100%",

        "& th": {
            fontWeight: 'bold',
            border: "1px solid #B0B0B0",
            backgroundColor: "#FAF3DE",
            padding: "2px 4px",
        },

        "& td": {
            border: "1px solid #B0B0B0",
            padding: "2px 4px",
        },

        "& label": {
            marginBottom: "0px",
        }
    },
});

export default function ReportCommOption({ state, setState }) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const { calMonths } = useSelector(state => {
        return state.selections;
    });

    // init
    if (_.isEmpty(state.calMonth) && !_.isEmpty(calMonths)) {
        setState({ ...state, calMonth: calMonths[0].format("YYYY-MM-DD") });
    }

    return (
        <div>
            <table className={clsx(classes.frmFilter, { "mb-3": true })}>
                <tbody>
                    <tr>
                        <th style={{ textAlign: 'right', width: '130px' }}>計算年度及月份：</th>
                        <td>
                            <CalMonthSelection value={state.calMonth} onChange={(e) => { setState({ ...state, calMonth: e.target.value }); }} tabIndex="1" />
                        </td>
                    </tr>
                    <tr>
                        <th style={{ textAlign: 'right', width: '130px' }}>佣金日期：</th>
                        <td>
                            <MyDateField dateValue={state.fDate} onDateChange={(d) => { setState({ ...state, fDate: d?.format("YYYY-MM-DD") }); }} tabIndex={1} />
                            &nbsp;至&nbsp;
                            <MyDateField dateValue={state.tDate} onDateChange={(d) => { setState({ ...state, tDate: d?.format("YYYY-MM-DD") }); }} tabIndex={2} />
                        </td>
                    </tr>
                    <tr>
                        <th rowSpan={2} style={{ textAlign: 'right', width: '130px' }}>列印選項：</th>
                        <td>
                            <RptCommSupervisorFilterRadioField state={state} setState={setState} fieldName="isHideNoReceivedAndNoBalance" label="隱藏本月無收數及沒有未收" value="__TRUE__" />
                            <RptCommSupervisorFilterRadioField state={state} setState={setState} fieldName="isHideNoReceivedAndNoBalance" label="所有交易" value="__FALSE__" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

function RptCommSupervisorFilterRadioField({ state, setState, fieldName, label, value }) {
    const name = `filter_${fieldName}`;
    const id = `${name}_${value}`;
    return <span className="mr-1 ml-1">
        <input className="mr-1" type="radio" value={value} id={id} name={name} onChange={(e) => { setState({ ...state, [fieldName]: e.target.value, }); }} checked={state[fieldName] == value} />
        <label htmlFor={id}>{label}</label>
    </span>;
}
